import toUint8Array from 'urlb64touint8array'

export const API_URL =  'https://api.duoreading.io/v2'
export const PUSH_SERVER_KEY = toUint8Array('BCqN5LMkX0OJT-2rj5VhymBYGjZ1N9zyD_mvPCun4-6V8HM-1YkqfbhOXRxNoK_AIcre-nnB5kLLVWQjR5W_2I0')
